var _style, _path, _line, _path2, _path3, _path4, _polyline, _polyline2, _polyline3, _polyline4, _circle, _line2, _line3, _path5, _path6, _line4, _line5, _path7, _path8, _path9, _path10, _line6, _path11, _line7, _polyline5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidecut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st362{fill:#FFFFFF;stroke:#000000;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st361{fill:none;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n\t.st360{fill:#FFFFFF;stroke:#000000;stroke-width:1.73;stroke-miterlimit:10;}\n\t.st359{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st358{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st357{fill:none;stroke:#000000;stroke-width:0.43;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st356{fill:#FFFFFF;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n\t.st355{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M223.4,387.6l0.8,20.5l0.3,7.1l52.6,7.2l0.8-6.9l0,0l5.2-43.9l2.2-72.6l4-45.8c-0.5-12.9-0.8-26.6-1.6-40.5 L275,137l-3.3-7.4c-5.4-6.8-9.1-19.4-9.1-19.4l-0.9-0.5l-11.7-3.3l-2-1.7l-3.5,1.6l-19.4,8.6l-27.3,12l-1,0.4l-0.6,0.3l-3.4,2 l2.4,8.2l1.6,5.1l-2.4,7.2l-16.2,47.3l-27,180.8l-0.5,3.7l-2.7,17.8l1.1,0.4l19.8,7.5l48.5,6.7L223.4,387.6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st361",
    x1: 195.2,
    y1: 137.8,
    x2: 200.4,
    y2: 134.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st360",
    d: "M194.2,124.4l28.2-21.2c2-1.5,4.3-2.6,6.7-3.3l8-2.3c2.9-0.9,5.9-1,8.8-0.3l15.4,1.5l1.6,11.6l-13.6-2.2 c-1.7-0.5-3.6-0.5-5.3,0l-6.5,1.4c-2,0.6-3.9,1.6-5.6,2.8l-9.6,6.7l-13.5,14l-8,8.8L194.2,124.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st359",
    d: "M196.6,124.9l26.9-20.2c1.8-1.4,3.9-2.4,6.1-3l8-2.3c1.4-0.4,2.9-0.6,4.4-0.6c1.2,0,2.4,0.2,3.5,0.4l14.2,1.1 l1,7.2l-10.9-1h-0.2c-1-0.3-2.1-0.4-3.2-0.4c-1,0-1.9,0.2-2.8,0.4l-6.6,1.4h-0.1c-2.2,0.7-4.3,1.7-6.1,3l-9.7,6.6l-13.8,13.9 l-5.9,6.8L196.6,124.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M269.4,205.8L252.7,338c-0.3,2.9-1.8,5.6-4.2,7.4l-77.1,60.4l-20.1-27.5l52.1-60.7c1.8-2.1,2.9-4.8,2.9-7.5 L208,264c0.1-2-0.1-4.1-0.4-6.1l-7.8-45.8c-0.4-2.4-0.6-4.8-0.6-7.3v-14.1c0-5.2,1.5-10.3,4.4-14.7l5.5-8.2 c4.9-7.4,13.1-12.1,22-12.6l1.5-0.1c5.9-0.3,11.8,1.7,16.3,5.6l11.9,10.5c3.5,3.2,5.8,7.6,6.3,12.3L269.4,205.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st358",
    points: "164.5,400.8 190.8,380.3 196.8,380.3 196.8,385.9 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st357",
    points: "197.6,128.9 195.2,130.8 198.6,142.4 196.1,150.3 187.4,178.1 180.8,198 150.1,400.2 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st357",
    points: "170.2,406.7 168.2,406 149.3,398.9 149.3,398.9 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st362",
    points: "151.3,378.2 134.1,398.2 152.3,420.7 171.4,405.8 151.3,378.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.6,
    cy: 409.9,
    r: 2.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st358",
    x1: 154.4,
    y1: 419.1,
    x2: 135.8,
    y2: 396.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st358",
    x1: 149.5,
    y1: 380.3,
    x2: 169.5,
    y2: 407.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st356",
    d: "M274.4,137.5l-4,3c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M273.7,136.6l-4.4,2.9c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st361",
    x1: 218.4,
    y1: 122.4,
    x2: 216,
    y2: 160.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st358",
    x1: 219.5,
    y1: 122.4,
    x2: 217,
    y2: 160.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st361",
    d: "M225.4,363.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st362",
    d: "M294.8,299.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M223.6,424.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M176.7,401.6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st358",
    x1: 277.9,
    y1: 415.6,
    x2: 277.9,
    y2: 415.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M224.2,408.2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st355",
    x1: 225.2,
    y1: 364.1,
    x2: 223.9,
    y2: 382.1
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st358",
    points: "179.6,400.2 213.6,404.8 221.4,375.1 227.9,376 228.3,406.7 277.1,413.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidecut);
export default __webpack_public_path__ + "static/media/SIDE CUT.e55bf5739b9d64e25eb4270cd7bb42a3.svg";
export { ForwardRef as ReactComponent };